<template>
  <ul class="aoformdroplist" role="listbox">
    <li role="option" 
        v-for="(option, index) in options" 
        :key="option + '-' + index"
        ref="lis"
        @click="optionSelect(option, index)"
        @keydown.enter.space="optionSelect(option, index)"
        @keydown.down.stop.prevent="()=>(index < options.length - 1) && this.$el.querySelectorAll('li[role=option]')[index + 1].focus()"
        @keydown.up.stop.prevent="()=>index ? this.$el.querySelectorAll('li[role=option]')[index - 1].focus() : ($el.closest('label') && $el.closest('label').querySelector('input:not([hidden]),button').focus())"
        :tabindex="($store.getters.loading || tabimmune)?-1:0"
        v-html="searchedOptions[index]"
      ></li>
  </ul>
</template>

<script>
export default {
  props: {
    options: {type: Array, required: true},
    search: {type: String, default: ''},
    tabimmune: {default: false}
  },
  methods:{
    focus(){
      let li = this.$el.querySelector('li[role=option]')
      if (li) li.focus()
    },
    optionSelect(option, index){
      this.$emit('update:modelValue', option)
      this.$emit('input', option, index)
      document.activeElement? document.activeElement.blur() : false
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }    
  },
  computed:{
    searchedOptions(){
      if (!this.search)
        return this.options

      return this.options.map(option=>{
        let s = this.search
        let searchRegExp = new RegExp(this.escapeRegExp(s),'gi')
        while(option . match(searchRegExp) == null && s.length > 1) {
          s = s.substring(0, s.length - 1)
          searchRegExp = new RegExp(this.escapeRegExp(s), 'gi') 
        }
        if (s.length)
          option = option.replace(searchRegExp, `<span class="aoformdroplist__red">${s}</span>`)
        return option 
      })
    }
  }
}
</script>

<style lang="sass">

.aoformdroplist
  display: block
  pointer-events: none
  opacity: 0
  width: 100%
  position: absolute
  z-index: 1
  top: calc(100% + 7px)
  left: 0
  background: colors.$mainbg
  padding: 0
  margin: 0
  box-shadow: 0 2px 5px rgba(0,0,0,.2)
  li
    display: block
    outline: none
    cursor: pointer
    color: colors.$gray3
    font-size: 18px
    line-height: 26px
    padding: 10px 18px
    &:hover, &:focus
      background: colors.$newestsilver
  &__red
    color: colors.$newred

</style>